/**
 * Kpop Spotlight — the photocard rail under a single spotlight: prev/next
 * buttons once the rail overflows, and a gentle tilt + glare that follows the
 * pointer, like the hero's photocard.
 */

import { reducedMotion } from './player.js';

function initRail(rail) {
	const ctl = rail.parentElement.querySelector('[data-spot-rail-ctl]');
	const [prev, next] = ctl ? ctl.querySelectorAll('button') : [];

	const sync = () => {
		const max = rail.scrollWidth - rail.clientWidth;
		if (ctl) ctl.hidden = max <= 4;
		if (prev) prev.disabled = rail.scrollLeft < 4;
		if (next) next.disabled = rail.scrollLeft > max - 4;
	};
	const step = () => {
		const card = rail.querySelector('.spot-pc');
		return card ? card.getBoundingClientRect().width + 17.6 : rail.clientWidth * 0.8;
	};

	ctl?.querySelectorAll('button').forEach((b) =>
		b.addEventListener('click', () => rail.scrollBy({ left: step() * Number(b.dataset.dir), behavior: reducedMotion() ? 'auto' : 'smooth' }))
	);
	rail.addEventListener('scroll', sync, { passive: true });
	window.addEventListener('resize', sync);
	sync();

	if (!window.matchMedia('(hover: hover)').matches || reducedMotion()) return;
	rail.querySelectorAll('.spot-pc').forEach((card) => {
		card.addEventListener('pointermove', (e) => {
			const r = card.getBoundingClientRect();
			const x = (e.clientX - r.left) / r.width;
			const y = (e.clientY - r.top) / r.height;
			card.style.setProperty('--ry', `${(x - 0.5) * 10}deg`);
			card.style.setProperty('--rx', `${(0.5 - y) * 10}deg`);
			card.style.setProperty('--mx', `${x * 100}%`);
			card.style.setProperty('--my', `${y * 100}%`);
		});
		const flat = () => {
			card.style.setProperty('--rx', '0deg');
			card.style.setProperty('--ry', '0deg');
		};
		card.addEventListener('pointerleave', flat);
		card.addEventListener('pointerdown', flat); // the picture should leave a flat card
	});
}

export function initRails() {
	document.querySelectorAll('[data-spot-rail]').forEach(initRail);
}
